import Tr from 'translations/Translations';

export const OfferEspdType = {
    EXTERNAL: "EXTERNAL",
    INTERNAL: "INTERNAL"
}
const _TR_PREFIX = 'offer_espd_type_';
export const OfferEspdTypeLabel = (type) => (Tr(_TR_PREFIX + type.toLowerCase()));
